module.exports = __webpack_public_path__ + "static/media/HomeLoginBG.63f8255d.svg";